import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 35083 34200"
    {...props}
  >
    <path
      d="m11533 18769 6006-2561-3843 5279-1800 2474-7731 2895 4553-6886 2815-1201zm12529-2263 3056 139 7089-4228-8221-747-8447 4537 6523 299zm-8265 5994-816 2948 2544 7854 2558-7850-2544-9245-1742 6293zm5575-1007 1796 2476 7727 2906-4542-6892-8814-3776 3833 5286zm-3837-5286v-2l-8437-4549-8222 734 7083 4239 9580-422-3-2-1 2zm-4289-4919 4288 4915-1661-9472-5739-5930 1101 8181 2011 2306zm4290 4916 3 4-2-9-1 5zm1171-6423 3 3-1171 6423 4300-4913 2015-2302 1114-8180-5713 5966-548 3003z"
      style={{
        fill: "#000",
        stroke: "#fefefe",
        strokeWidth: 555.518,
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
